import actions from './actions';
import appearance from './appearance';
import errors from './errors';
import order from './order';
import services from './services';

export const actionstype = actions;
export const appearancetype = appearance;
export const errorstype = errors;
export const ordertype = order;
export const servicestype = services;
